<div class="navbar">
  <button
    class="btn btn-link no-wrap"
    [disabled]="!canGoBack()"
    (click)="goBack()"
    [ngbTooltip]="'Go back' | translate"
    placement="bottom-start"
  >
    <i class="far fa-fw fa-arrow-left"></i>
  </button>
  <button
    class="btn btn-link home-button"
    (click)="goHome()"
    [ngbTooltip]="'Go home' | translate"
    placement="bottom"
  >
    @if (panel.isUxpPanel) {
      <i class="far fa-fw fa-home"></i>
    } @else {
      @if (!parameters.values.brandingLogo) {
        <img src="/assets/logo.svg" focusable="false" [alt]="'Logo' | translate" />
      }
      @if (parameters.values.brandingLogo) {
        <img [src]="parameters.values.brandingLogo" [alt]="'Logo' | translate" />
      }
    }
  </button>
  <div class="title-wrapper">
    <strong class="title no-wrap">{{ title.getTitle() }}</strong>
  </div>
  <a
    class="btn btn-link"
    routerLink="/media/search"
    [ngbTooltip]="'Search across all Media Roots' | translate"
    placement="bottom bottom-end"
  >
    <i class="far fa-fw fa-search"></i>
  </a>
  @if (panel.app !== "AEFT" && panel.app !== "MediaComposer") {
    <button
      class="btn btn-link"
      [disabled]="!hostConnected"
      (click)="syncMetadata()"
      [ngbTooltip]="
        hostConnected
          ? ('Download comments, markers and tags' | translate)
          : ('Premiere Pro is not connected' | translate)
      "
      placement="bottom bottom-end"
    >
      <i class="far fa-fw fa-download"></i>
      <new-badge version="23.10" />
    </button>
  }
  @if (!proxyPanelVisible && panel.app !== "AEFT" && panel.plugin.hasProxy) {
    <button
      class="btn btn-link proxy-panel-button"
      (click)="proxyPanelVisible = true"
      [ngbTooltip]="'Proxy mode settings' | translate"
      placement="bottom bottom-end"
    >
      <img class="icon" src="/assets/icons/panel/proxy.png" alt="" />
    </button>
  }
  @if (proxyPanelVisible && panel.app !== "AEFT" && panel.plugin.hasProxy) {
    <button class="btn btn-link proxy-panel-button active" (click)="proxyPanelVisible = false">
      <img class="icon" src="/assets/icons/panel/proxy.png" alt="" />
      @if (proxyPanelVisible) {
        <span class="label" translate>Proxy mode settings</span>
      }
    </button>
  }
  <button
    class="btn btn-link"
    [ngbTooltip]="'Logged in as {user}' | translate: { user: identity.user?.displayName }"
    placement="bottom bottom-end"
  >
    <i class="far fa-fw fa-user"></i>
  </button>
  @if (!identity.user?.isExternal) {
    <div class="d-flex" ngbDropdown display="dynamic" placement="bottom-end bottom-start auto">
      <button
        class="btn navbar-btn btn-notification"
        ngbDropdownToggle
        [title]="'Notifications' | translate"
        data-test-qa="notificationHistoryDropdown"
      >
        @if (!notifyHistory.pagination.unread) {
          <i class="far fa-bell"></i>
        }
        @if (notifyHistory.pagination.unread) {
          <badge scheme="primary" shape="pill">
            <badge-prefix><i class="far fa-bell"></i></badge-prefix>
            {{ notifyHistory.pagination.unread }}
          </badge>
        }
      </button>
      <notification-dropdown ngbDropdownMenu />
    </div>
  }
  @if (panel.plugin.hasRestart()) {
    <button
      class="btn btn-link"
      (click)="restart()"
      [ngbTooltip]="'Restart extension' | translate"
      placement="bottom bottom-end"
    >
      <i class="far fa-fw fa-rotate-right"></i>
    </button>
  }
</div>
@if (proxyPanelVisible) {
  <div class="proxy-panel btn-toolbar">
    <button
      class="btn btn-secondary"
      [disabled]="!hostConnected"
      (click)="cacheAndAttachSequenceProxies()"
      [ngbTooltip]="
        hostConnected
          ? ('Attach proxies for the active sequence' | translate)
          : ('Premiere Pro is not connected' | translate)
      "
      placement="bottom bottom-start"
    >
      <i class="far fa-download"></i>
      <span translate>Sequence</span>
    </button>
    <button
      class="btn btn-secondary"
      [disabled]="!hostConnected"
      (click)="cacheAndAttachProjectProxies()"
      [ngbTooltip]="
        hostConnected
          ? ('Attach proxies for this project' | translate)
          : ('Premiere Pro is not connected' | translate)
      "
      placement="bottom bottom-end"
    >
      <i class="far fa-download"></i>
      <span translate>Project</span>
    </button>
    <div class="btn-group">
      @if (proxyCache.runningJobs.length) {
        <button class="btn btn-secondary" disabled>
          Caching - {{ proxyCache.runningJobs.length + proxyCache.cacheQueue.length }} left
        </button>
      }
      @if (proxyCache.runningJobs.length) {
        <button class="btn btn-secondary" (click)="proxyCache.abortAll()">Stop</button>
      }
    </div>
    @if (panel.plugin.hasConfig() || !proxyCache.runningJobs.length) {
      <button
        class="btn btn-link"
        (click)="proxyDirChange()"
        placement="bottom"
        [ngbTooltip]="proxyCache.cachePath"
      >
        <i class="far fa-folder"></i>
        <span translate>Cache location</span>
      </button>
    }
    @if (panel.plugin.canToggleProxyMode) {
      @if (!proxyMode) {
        <button class="btn btn-secondary proxy-toggle" (click)="setProxyMode(true)">
          <img class="icon" src="/assets/icons/panel/proxy.png" alt="" />
          <span>Hi-res mode</span>
        </button>
      }
      @if (proxyMode) {
        <button class="btn btn-dark active proxy-toggle" (click)="setProxyMode(false)">
          <img class="icon" src="/assets/icons/panel/proxy-active.png" alt="" />
          <span>Proxy mode</span>
        </button>
      }
    }
  </div>
}
<div class="layout-main platform-{{ panel.platform }}">
  <div class="animate-view" [@routeChanging]="routeLogger.routeChanging$ | async">
    <router-outlet />
  </div>
  <div [hidden]="!(routeLogger.routeChanging$ | async)">
    <spinner-icon />
  </div>
</div>
<uploader-panel />
